import Endpoints from "../../constants/endpoints.js";
import { LocalStorageKeys } from "../../constants/storageKeys.js";
import httpService from "../httpService.js";
import localStorageService from "../localStorageService.js";

const create = async (payload) => {
  const url = Endpoints.tattles.create;
  const response = await httpService.post(url, {
    ...payload,
  });

  return response;
};

/**
 *
 * @param {int} id The product id
 * @returns
 */
const deleteTattle = async (id) => {
  const url = Endpoints.tattles.delete.replace("{id}", id);
  const response = await httpService.delete(url);

  return response;
};

const get = async (id) => {
  const url = Endpoints.tattles.get.replace("{id}", id);
  const response = await httpService.get(url);

  return response;
};

const getByUniqueIds = async (uniqueIds) => {
  const url = Endpoints.tattles.byUniqueIds;
  const response = await httpService.post(url, { uniqueIds });

  return response;
};

const getTattleInfo = async (id) => {
  const url = Endpoints.tattles.deviceInfo.replace("{uniqueId}", id);
  const response = await httpService.get(url);

  return response;
};

const getPorts = async (tattleId) => {
  const url = Endpoints.tattles.portsByTattleId.replace(
    "{tattleId}",
    tattleId
  );
  const response = await httpService.get(url);

  return response;
};

/**
 *
 * @param {SearchFilterRequest} filter
 * @returns
 */
const getTattles = async (filter, allBranches = false, clientId = null) => {
  if (clientId == null) {
    clientId = localStorageService.getProperty(
      LocalStorageKeys.currentClient
    )?.id;
  }
  const url = Endpoints.tattles.filter.replace(
    "{clientId}",
    allBranches ? "" : clientId
  );
  const response = await httpService.post(url, filter);

  return response;
};

const save = async (payload) => {
  return payload?.id > 0 ? await update(payload) : await create(payload);
};

const update = async (payload) => {
  const url = Endpoints.tattles.update.replace("{id}", payload?.id);
  const response = await httpService.put(url, {
    ...payload,
  });

  return response;
};

//-----------------------------------------//
const tattlesApiService = {
  delete: deleteTattle,
  get,
  getByUniqueIds,
  getPorts,
  getTattleInfo,
  getTattles,
  save,
};

export default tattlesApiService;
//-----------------------------------------//
